import { portfolioData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function PortfolioSection() {
  return (
    <section id="portfolio" className="py-20 md:py-28 bg-background-50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {portfolioData.heading}
            </h2>
            <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        {/* Asymmetric grid: first two larger, then 4 smaller */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {portfolioData.items.slice(0, 2).map((item, i) => (
            <AnimatedSection key={item.title} delay={i * 150}>
              <div className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-accent-300/30 transition-all duration-400 card-lift img-scale-hover h-full flex flex-col">
                <div className="relative h-56 md:h-64 lg:h-72 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-primary-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                  <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
                    <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-primary-700 text-xs font-semibold backdrop-blur-sm">
                      {item.industry}
                    </span>
                    <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-secondary-700 text-xs font-semibold backdrop-blur-sm">
                      {item.tech}
                    </span>
                  </div>
                </div>
                <div className="p-6 md:p-7 flex-grow flex flex-col">
                  <h3 className="text-xl font-bold text-foreground-950 mb-2.5 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5 flex-grow">
                    {item.desc}
                  </p>
                  <a
                    href="/portfolio"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600 hover:text-accent-700 transition-colors btn-arrow-hover group/link mt-auto"
                  >
                    View Case Study
                    <i className="ri-arrow-right-line btn-arrow text-xs" />
                  </a>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {portfolioData.items.slice(2).map((item, i) => (
            <AnimatedSection key={item.title} delay={i * 120 + 300}>
              <div className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-accent-300/30 transition-all duration-400 card-lift img-scale-hover h-full flex flex-col">
                <div className="relative h-40 md:h-44 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                </div>
                <div className="p-5 flex-grow flex flex-col">
                  <div className="flex items-center gap-2 mb-2.5">
                    <span className="px-2 py-0.5 rounded bg-primary-50 text-primary-700 text-[10px] font-bold uppercase tracking-wider">
                      {item.industry}
                    </span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-950 mb-1.5 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3 flex-grow">
                    {item.desc}
                  </p>
                  <a
                    href="/portfolio"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600 hover:text-accent-700 transition-colors btn-arrow-hover group/link mt-auto"
                  >
                    View Case Study
                    <i className="ri-arrow-right-line btn-arrow text-[10px]" />
                  </a>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection delay={400}>
          <div className="text-center mt-12 md:mt-16">
            <a
              href="/portfolio"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316] text-white text-sm font-semibold rounded-xl hover:brightness-110 hover:-translate-y-0.5 transition-all duration-300 shadow-lg shadow-[#7C3AED]/25 whitespace-nowrap btn-arrow-hover group"
            >
              {portfolioData.cta}
              <i className="ri-arrow-right-line btn-arrow" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}